'use strict';
import isObject from 'lodash/isObject';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {buildParentChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {sortByProperty} from '../../core-utilities/filters/filterUtils';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {SYNC_PATH} from '../../core-utilities/rx-utils';
import {logger} from './logger';


/**
 * @param {Object} config
 * @param {String} config.prefix
 * @param {Function} config.getState
 * @param {String} config.parentPath
 * @param {String} config.childPath
 * @return {{reduxList: ReduxList, componentOptions: ReduxListComponentOptions, isVisible: *}}
 */
export function makeMilestoneList(config) {
  const {
    prefix,
    getState,
    parentPath,
    childPath,
  } = config;

  const matchesAutoFilter = applyAutoFilter(['name'], 1);

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    prefix,
    getState,
    pageSize: 100,
    hasParentId: true,
    useDelete: false,
    useFiltering: true,
    useAutoFilter: true,
    useFilterOptions: false,
    useSortOptions: false,
    isVisible,
    applySortOptions,
    syncNotifier: buildParentChannelSyncNotifier(parentPath, childPath),
    listPath: parentId => `${parentPath}/${parentId}/${childPath}`,
    listSyncPath: parentId => `${parentPath}/${parentId}/${childPath}/${SYNC_PATH}`,
    logger,
  });

  const componentOptions = applyDefaultReduxListComponentOptions(reduxList.options);

  function isVisible(item, filterData) {
    if (!isObject(item)) return false;
    if (!matchesAutoFilter(item, filterData.filter)) return false;
  }

  return {
    reduxList,
    componentOptions,
    isVisible,
  };
}

function applySortOptions(list) {
  return list.sort(sortByProperty('name', true, true));
}



// WEBPACK FOOTER //
// ./src/js/milestones/redux/configMilestonesList.js